import { NavLink } from 'react-router-dom';
import css from './Side.module.css';
import { providerMenu } from '../Menus/ProviderMenu';

function PrSider() {
    return (
        <aside className={css.sideMenu}>
            <menu>
                {providerMenu.map((item) => (
                    <NavLink key={item.key} to={item.key} className={css.menuItem} end >
                        {item.icon}
                        <span>{item.label}</span>
                    </NavLink>
                ))}
            </menu>
        </aside>
    );
}

export default PrSider;